import { useLocalStorage } from "@mantine/hooks"

// Device-local "demo mode" for the portal. Mirrors apps/nexus/src/hooks/useDemoMode.ts
// with ONE deliberate difference: it defaults to OFF.
//
// Nexus defaults ON because its demo screens are unbuilt-but-coming — showing them
// (tagged) is the honest default. The portal's hidden screens are the opposite case:
// they are built, they render, and they are OUT OF DATE. A stale page that looks live
// is worse than a missing one, so a fresh device sees only current screens and someone
// who wants the in-progress ones opts in.
//
// Per-device on purpose: off on the laptop you demo from, on at the desk where you are
// fixing the stale pages. Mantine useLocalStorage keeps every instance in this tab in
// sync, so the shell and the top bar share one source.
export const DEMO_MODE_KEY = "civala.demoMode.portal"

export const useDemoMode = () =>
  useLocalStorage<boolean>({
    key: DEMO_MODE_KEY,
    defaultValue: false,
    getInitialValueInEffect: false,
  })
